import { KBarProvider } from "kbar";
import { useNavigate } from "react-router-dom";
import { globalSearchActions } from "./utils/actions";
import KBarContent from "./KBarContent";

const GlobalSearchProvider = ({ children }: { children: React.ReactNode }) => {
    const navigate = useNavigate();

    const actions = globalSearchActions.map(action => ({
        ...action,
        perform: action.perform ? () => action.perform(navigate) : undefined,
    }));

    return (
        <KBarProvider actions={actions}>
            {children}
            <KBarContent />
        </KBarProvider>
    );
};

export default GlobalSearchProvider;
